export enum EAppIntegrationAccountSettingsKey {
  GET_PRODUCTS_FILTER = 'GET_PRODUCTS_FILTER',
}
